import { zodResolver } from "@hookform/resolvers/zod";
import type { FieldValues, Resolver } from "react-hook-form";
import type { ZodTypeAny } from "zod/v3";

/**
 * Bridges Zod v3 schemas (zod/v3) with @hookform/resolvers when the app root
 * depends on Zod 4 for json-render agent chat. Runtime validation uses Zod 3
 * error shape, which @hookform/resolvers 3.x expects.
 */
export function zodV3Resolver<TFieldValues extends FieldValues>(schema: ZodTypeAny): Resolver<TFieldValues> {
  return zodResolver(schema as never) as Resolver<TFieldValues>;
}
